import React from 'react';
import injectSheet from 'react-jss';

import { FormattedMessage } from 'react-intl';

import styles from './UnsupportedBrowserPage.styles';

function UnsupportedBrowserPage(props) {
  const { classes } = props;

  return (
    <div className={classes.unsupportedBrowserContainer}>
      <div className={classes.unsupportedBrowserMessage}>
        <div className={classes.unsupportedBrowserImageContainer}>
          <img
            className={classes.unsupportedBrowserContainerLogo}
            alt="Evisort"
            title="Evisort"
            src="./evisort.png"
          />
        </div>
        <FormattedMessage
          id="UnsupportedBrowserPage.browserNotSupported"
          defaultMessage="Your web browser is not supported. Please log into Evisort <link>using a supported web browser</link>."
          description="Message informing user their browser is not supported with link to supported browsers"
          values={{
            link: (chunks) => (
              <a
                href="https://support.evisort.com/hc/en-us/articles/360044832854-System-Requirements"
                target="_blank"
                rel="noreferrer"
              >
                {chunks}
              </a>
            ),
          }}
        />
      </div>
    </div>
  );
}

export default injectSheet(styles)(UnsupportedBrowserPage);
